import React from 'react';
import './LiveTranscriptSubtitle.css';

const LiveTranscriptSubtitle = ({ liveTranscript, interimTranscript, isTranscribing }) => {
    // Combine final and interim transcripts
    const displayText = liveTranscript || interimTranscript;
    
    if (!isTranscribing || !displayText) {
        return null;
    }

    return (
        <div className="live-transcript-container">
            <div className="live-transcript-subtitle">
                {interimTranscript && !liveTranscript && (
                    <span className="interim-text">{interimTranscript}</span>
                )}
                {liveTranscript && (
                    <span className="final-text">{liveTranscript}</span>
                )}
            </div>
            <div className="transcript-indicator">
                <span className="recording-dot"></span>
                <span className="transcript-label">Live Transcription</span>
            </div>
        </div>
    );
};

export default LiveTranscriptSubtitle;
